export const fileDownloadHelper = (blob, name) => {
    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
        window.navigator.msSaveBlob(blob, name);
    } else {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = name;
        a.click();
    }
};


export const loopThroughCurrentMonthDays = (isInEdit, activityMonth) => {
    const today = new Date();
    const year = today.getFullYear();
    const month = isInEdit ? activityMonth : today.getMonth();

    const lastDayOfMonth = new Date(year, month + 1, 0);
    const numberOfDays = lastDayOfMonth.getDate();

    const daysList = [];
    for (let day = 1; day <= numberOfDays; day++) {
        const currentDate = new Date(year, month, day);

        const dayOfMonth = currentDate.getDate();
        const monthOfYear = isInEdit ? activityMonth + 1 : currentDate.getMonth() + 1;
        const fullYear = currentDate.getFullYear();
        const shortMonthName = currentDate.toLocaleDateString('en-US', { month: 'short' });

        const formattedDay = dayOfMonth < 10 ? '0' + dayOfMonth : dayOfMonth;
        const formattedMonth = monthOfYear < 10 ? '0' + monthOfYear : monthOfYear;
        
        const formattedDate = `${formattedDay}-${shortMonthName}`;
        const dateValue = `${fullYear}-${formattedMonth}-${formattedDay}`;

        daysList.push({'formattedDate': formattedDate, 'dateValue': dateValue});
    }
    return daysList;
}